import React from "react";

import CollapseComponent from "../CommonComponents/CollapseComponent";
import TransferTree from "./TransferTree";

const SelectorZIP = ({ featureNumber }) => {
  return (
    <CollapseComponent key="ZIP base" groupTitle="Open ZIP selector">
      <TransferTree featureNumber={featureNumber} />
    </CollapseComponent>
  );
};

export default SelectorZIP;
